define('Header.MiniCart.View.Extension', [
  'Header.MiniCart.View',
  'underscore',
  'jQuery',
  'Utils'
], function (
  HeaderMiniCartView,
  _,
  jQuery,
  Utils
) {
  'use strict';
  _.extend(HeaderMiniCartView.prototype, {
    getContext: _.wrap(HeaderMiniCartView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));

      var lines = context.model.get('lines').models;
      var newLines = [];
      var newSubtotal = 0;
      lines.forEach(function (line) {
        var options = line.get('options').models;
        var rate = _.find(options, function (option) {
          return option.get('cartOptionId') === 'custcol_custom_price';
        });
        if (rate && rate.get('value')) {
          line.set('rate', parseFloat(rate.get('value').label));
        }
        newLines.push(line);
        newSubtotal += line.get('rate') * line.get('quantity');
      }
      );
      if (context.model.get('summary')) {
        context.model.get('summary').subtotal_formatted = Utils.formatCurrency(newSubtotal);
        context.subtotalFormatted = Utils.formatCurrency(newSubtotal);
      }
      return context;
    }),
    // var result = fn.apply(this, _.toArray(arguments).slice(1));
    // var lines = result.lines;
    // var newLines = [];
    // var newSubtotal = 0;
    // lines.forEach(function (line) {
    //   var options = line.options;
    //   var rate = _.find(options, function (option) {
    //     return option.cartOptionId === 'custcol_configurable_price';
    //   });
    //   if (rate) {
    //     line.rate = parseFloat(rate.value.label);
    //   }
    //   newLines.push(line);
    //   newSubtotal += line.rate * line.quantity;
    // });
    // result.lines = newLines;
    // result.summary.subtotal_formatted = Utils.formatCurrency(newSubtotal);
    // return result;
    // initialize: _.wrap(HeaderMiniCartView.prototype.initialize, function (fn) {
    //   fn.apply(this, _.toArray(arguments).slice(1));
    //   debugger
    //   this.model.on('change', this.render, this);
    // }),
    // reCalcPrice: function () {
    //   debugger
    //   var self = this;
    //   var item = this.model.get('item');
    //   var quantity = this.model.get('quantity');
    //   var price = item.get('onlinecustomerprice_detail').onlinecustomerprice_formatted;
    //   var newPrice = parseFloat(price.replace('$', '').replace(',', '')) * quantity;
    //   this.model.set('total', newPrice);
    //   this.render();
    // }
  });
});
